const messages = {
	es: {
		translations: {
			signup: {
				title: "Crear cuenta",
				step1Title: "Ingresa CNPJ y correo para comenzar.",
				step2Title: "Ingresa el código enviado a tu correo.",
				step3Title: "Completa los datos de la empresa y la contraseña.",
				toasts: {
					success:
						"¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
					fail: "Error creando el usuario. Verifica la data reportada.",
					codeSent: "Código enviado a tu correo.",
					emailValidated: "Correo verificado. Completa los datos abajo.",
				},
				form: {
					companyName: "Nombre de la empresa",
					companyNamePlaceholder: "Nombre de su empresa",
					cnpj: "CNPJ",
					cnpjPlaceholder: "00.000.000/0000-00",
					cnpjIncomplete: "El CNPJ debe tener 14 dígitos.",
					cnpjInvalid: "CNPJ inválido. Verifique los dígitos.",
					name: "Nombre completo",
					namePlaceholder: "Maria Silva",
					email: "Correo electrónico",
					emailPlaceholder: "tu@ejemplo.com",
					emailInvalid: "Correo inválido.",
					password: "Contraseña",
					passwordPlaceholder: "Mínimo 8 caracteres",
					passwordHint: "Mín. 8 caracteres, 1 mayúscula y 1 especial.",
					passwordWeak: "Contraseña débil: use 8+ caracteres, 1 mayúscula y 1 especial.",
					passwordStrengthWeak: "Débil",
					passwordStrengthMedium: "Media",
					passwordStrengthStrong: "Fuerte",
					phone: "Celular",
					countryCode: "País",
					phonePlaceholder: "(00) 00000-0000",
					code: "Código de verificación",
					codePlaceholder: "000000",
				},
				buttons: {
					sendCode: "Enviar código",
					sendingCode: "Enviando…",
					validateEmail: "Validar correo",
					validatingEmail: "Validando…",
					submit: "Crear cuenta",
					creating: "Creando cuenta…",
					login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
					loginPrefix: "¿Ya tienes una cuenta?",
					loginLink: "Entrar",
				},
				errors: {
					codeInvalidOrExpired: "Código inválido o expirado.",
					rateLimit: "Demasiados envíos. Intenta en 15 minutos.",
				},
			},
			login: {
				title: "Bienvenido de nuevo",
				subtitle: "Inicia sesión con tu cuenta para continuar.",
				form: {
					email: "Correo electrónico",
					emailPlaceholder: "tu@ejemplo.com",
					password: "Contraseña",
					passwordPlaceholder: "••••••••",
				},
				buttons: {
					submit: "Entrar",
					register: "¿No tienes una cuenta? Regístrate",
					registerPrefix: "¿No tienes una cuenta?",
					registerLink: "Regístrate",
					recover: "¿Olvidaste la contraseña?",
					showPassword: "Mostrar",
					hidePassword: "Ocultar",
				},
				toggle: {
					login: "Entrar",
					signup: "Registrarse",
				},
				hero: {
					tagline: "Todos tus canales en un solo lugar.",
					productSubtitle: "Multi Atención",
				},
			},
			recoverPassword: {
				title: "Olvidaste tu contraseña?",
				subTitle:
					"¡Sin problemas! Simplemente ingrese su correo electrónico y le enviaremos instrucciones de inicio de sesión.",
				form: {
					email: "Correo electrónico",
					emailPlaceholder: "Ingrese su correo",
					emailInvalid: "Ingrese un correo válido.",
				},
				buttons: {
					submit: "Recuperar contraseña",
					return: "Regresar",
				},
				toasts: {
					emailSent: "Si el correo está registrado, recibirá el enlace en breve.",
					checkInbox: "Revise su bandeja de entrada (y spam) y haga clic en el enlace para definir una nueva contraseña.",
				},
			},
			resetPassword: {
				title: "Nueva contraseña",
				subTitle: "Defina una nueva contraseña para su cuenta.",
				form: {
					password: "Nueva contraseña",
					passwordPlaceholder: "Ingrese la nueva contraseña",
					confirmPassword: "Confirmar contraseña",
					confirmPasswordPlaceholder: "Repita la nueva contraseña",
					passwordMismatch: "Las contraseñas no coinciden.",
				},
				buttons: {
					submit: "Guardar contraseña",
					returnLogin: "Ir al inicio de sesión",
					requestNew: "Solicitar nuevo enlace",
				},
				toasts: {
					success: "¡Contraseña actualizada! Inicie sesión.",
				},
				errors: {
					invalidLink: "Enlace inválido o expirado. Solicite la recuperación nuevamente.",
				},
			},
			auth: {
				toasts: {
					success: "¡Inicio de sesión exitoso!",
				},
			},
			errorFallback: {
				error: "Algo salió mal",
				instructions: "Recarga la página o intenta de nuevo en un momento. Si el problema continúa, contacta a soporte.",
				detail: "Detalle técnico",
			},
			dashboard: {
				epoch: {
					buttons: {
						today: "Hoy",
						week: "Semana",
						month: "Mes",
						year: "Año",
					},
				},
				charts: {
					perDay: {
						title: "Tickets hoy: ",
					},
					attendantsChart: {
						title: "Llamadas activas de asistentes",
						sideTitle: "Llamadas",
					},
					progressBar: {
						callsByDepartment: "Llamadas por departamento",
						callsByAttendant: "Llamadas del asistente",
						ratingsByAttendant: "Calificaciones del asistente",
					},
				},
				departments: {
					title: "Departamentos",
				},
				messages: {
					inAttendance: {
						title: "En servicio",
					},
					waiting: {
						title: "Esperando",
					},
					closed: {
						title: "Finalizado",
					},
					connection: {
						title: "Conexiones",
					},
					waitingTime: {
						title: "Tiempo medio de espera",
					},
					serviceTime: {
						title: "Tiempo promedio de servicio",
					},
					averageRating: {
						title: "Puntuación media",
					},
					contacts: {
						title: "Contactos",
					},
					messages: {
						title: "Mensajes",
					},
					reviews: {
						title: "Evaluaciones",
					},
				},
				infoCard: {
					ticketsToday: "Número de Tickets que se manejan.",
					awaitingService: "Número de Tickets en espera de servicio.",
					ticketsSolved: "Número de Tickets resueltos.",
					connections: "Número de canales conectados.",
					waitingTime:
						"Tiempo medio de espera de los tickets para ser atendidos.",
					serviceTime:
						"Tiempo medio en que los operadores realizan el servicio.",
					averageRating: "Valoración media de la valoración del servicio.",
					contactNumber: "Número total de contactos.",
					messagesNumber: "Número total de mensajes intercambiados.",
					reviews: "Número total de opiniones recibidas.",
				},
			},
			connections: {
				title: "Conexiones",
				subtitle: "Gestione canales, sesiones e integraciones de la plataforma.",
				listTitle: "Lista de conexiones",
				searchPlaceholder: "Buscar conexión...",
				empty: "No se encontraron conexiones.",
				emptyHint: "Pruebe con otro término de búsqueda.",
				toasts: {
					deleted:
						"¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
					webhookUpdated: "Webhook reconectado correctamente.",
				},
				confirmationModal: {
					deleteTitle: "Borrar",
					deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
					disconnectTitle: "Desconectar",
					disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
				},
				buttons: {
					add: "Agregar conexión",
					edit: "Editar",
					delete: "Eliminar",
					disconnect: "Desconectar",
					tryAgain: "Inténtalo de nuevo",
					qrcode: "QR CODE",
					newQr: "Nuevo QR CODE",
					connecting: "Conectando",
					restart: "Reinicia Backend",
					reconnectWebhook: "Reconectar webhook",
				},
				toolTips: {
					disconnected: {
						title: "No se pudo iniciar la sesión de WhatsApp",
						content:
							"Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
					},
					qrcode: {
						title: "Esperando la lectura del código QR",
						content:
							"Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
					},
					connected: {
						title: "Conexión establecida",
					},
					timeout: {
						title: "Se perdió la conexión con el teléfono celular",
						content:
							"Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
					},
				},
				table: {
					id: "ID de instancia",
					name: "Nombre",
					status: "Estado",
					lastUpdate: "Última Actualización",
					default: "Por Defecto",
					actions: "Acciones",
					session: "Sesión",
					channel: "Canal",
				},
				marketplace: {
					configured: "Ya configurado",
					configuredTitle: "Lista de canales ya agregados",
					configuredDescription: "Gestione las conexiones activas de su cuenta.",
					channelPrefix: "Canal",
					sessionStatus: {
						connected: "Conectado",
						connecting: "Conectando",
						qrcode: "Esperando código QR",
						disconnected: "Desconectado",
						timeout: "Sesión expirada",
						pairing: "Emparejando",
					},
					createdAt: "Creado el",
					hubBadge: "Hub",
					integrationTypes: {
						native: "Nativo",
						hub: "Hub",
						seamless: "Seamless",
					},
					channelTypes: {
						instagram: "Instagram V2",
						webchat: "WebChat",
						sms: "SMS",
						mercadolivre: "Mercado Libre",
						tiktok: "TikTok",
						ifood: "iFood",
						youtube: "YouTube",
						numero_virtual: "Número Virtual",
						olx: "OLX",
						linkedin: "LinkedIn",
						magalu: "Magalu",
						gbm: "Google My Business",
						google_ads: "Google Ads",
						meta_ads: "Meta Ads",
						shein: "Shein",
						shopee: "Shopee",
					},
				},
				wizard: {
					subtitle: "Siga los pasos para configurar la nueva conexión.",
					stepOf: "Paso {{current}} de {{total}}",
					channelSelected: "Canal seleccionado",
					back: "Volver",
					next: "Siguiente",
					errors: {
						nameRequired: "Ingrese el nombre de la conexión.",
					},
					stepDescriptions: {
						basic: "Elija un nombre y si será la conexión predeterminada.",
						messages: "Mensajes opcionales de saludo y despedida.",
						queues: "Defina sectores y comportamiento del chatbot.",
						whatsappcloud: "Ingrese los datos de la API oficial de WhatsApp Business.",
						facebook: "Ingrese el ID y el token de acceso de la página.",
						telegram: "Ingrese el token del bot de Telegram.",
						email: "Configure credenciales y servidores de correo.",
					},
					steps: {
						basic: "Información básica",
						credentials: "Credenciales",
						messages: "Mensajes",
						queues: "Filas y automatización",
						hubChannel: "Canal del Hub",
						hubDetails: "Detalles de la conexión",
					},
				},
				hubLinkModal: {
					title: "Vincular canal del Hub",
					subtitle:
						"Elija el canal autorizado en su cuenta NotificaMe Hub para activar como conexión.",
					channelLabel: "Canal autorizado en el Hub",
					channelPlaceholder: "Seleccione el canal",
					channelHint: "Cada ítem muestra el tipo de canal (WhatsApp, Instagram, Facebook…) y el nombre configurado en el Hub.",
					channelTypeLabel: "Tipo de canal",
					selected: "Seleccionado",
					submit: "Vincular conexión",
					emptyTitle: "No se encontraron canales autorizados",
					emptyDescription:
						"Configure el canal en el panel NotificaMe Hub e intente de nuevo.",
					errors: {
						channelRequired: "Seleccione un canal del Hub.",
						nameRequired: "Ingrese el nombre de la conexión.",
					},
				},
				picker: {
					title: "Agregar conexión",
					subtitle: "Elija un canal disponible o conéctese vía Seamless.",
					close: "Cerrar",
					recommended: "Recomendado",
					selectChannel: "Configurar conexión",
					addChannel: "Agregar",
					hubConnect: "Agregar",
					hubConnectSuccess: "¡Canal conectado con éxito!",
					hubConnectError: "Error al conectar el canal.",
					hubPopupBlocked: "Popup bloqueado. Permita popups para este sitio.",
					hubMissingCompany: "Token del Hub no configurado. Defínalo en Configuración.",
					hubTokenWarning: {
						title: "Token del Hub no configurado",
						description:
							"Para vincular canales vía Hub, informe el token de su cuenta NotificaMe (campo Account).",
						path: "Ruta: Configuración → Integraciones → Token Hub",
						link: "Configurar token del Hub",
					},
					seamlessTokenWarning: {
						title: "Integración Seamless no configurada",
						description:
							"Para agregar canales vía Seamless, informe el token de su cuenta NotificaMe.",
						path: "Ruta: Configuración → Integraciones → Token Hub",
						link: "Configurar token",
					},
					hubWhatsappNotEnabled: {
						help:
							"Habilite el canal WhatsApp en su cuenta NotificaMe (Seamless) e intente de nuevo. Use el token de la cuenta (campo Account), no de un canal específico.",
					},
					sections: {
						native: {
							title: "Canales disponibles",
							description:
								"WhatsApp nativo (QR) o vincule canales ya configurados en su cuenta NotificaMe Hub.",
						},
						hub: {
							title: "Canales vía Hub",
							description:
								"Vincule canales ya configurados en su cuenta NotificaMe Hub (WhatsApp, Facebook, Instagram, correo y otros).",
						},
						seamless: {
							title: "Canales vía Seamless",
							description:
								"Conecte Facebook, Instagram, WhatsApp, YouTube, Google Business, LinkedIn, OLX, Mercado Libre y TikTok mediante la integración Seamless de NotificaMe. Haga clic en Agregar para autorizar en la plataforma.",
						},
					},
					channels: {
						whatsapp: {
							description: "Conecte vía código QR con sesión local.",
						},
						whatsappcloud: {
							description: "Use la API oficial de WhatsApp Business (Meta).",
						},
						email: {
							label: "Correo electrónico",
							description: "Configure envío y recepción por SMTP/IMAP.",
						},
						telegram: {
							description: "Conecte un bot de Telegram con token.",
						},
						facebookNative: {
							description: "Conexión manual con credenciales de la página.",
						},
						instagramNative: {
							description: "Conexión manual con credenciales del perfil.",
						},
						hubIntegration: {
							label: "NotificaMe Hub",
							description:
								"Seleccione un canal ya autorizado en su cuenta Hub para activar en la plataforma.",
						},
						hubFacebook: {
							description: "Página de Facebook conectada vía OAuth Seamless.",
						},
						hubInstagram: {
							description: "Instagram Direct conectado vía OAuth Seamless.",
						},
						hubWhatsapp: {
							description: "WhatsApp Business (API Meta) conectado vía OAuth Seamless.",
						},
						hubYoutube: {
							description: "Comentarios del canal de YouTube conectados vía OAuth Seamless.",
						},
						hubGoogleBusiness: {
							description: "Perfil de empresa en Google conectado vía OAuth Seamless.",
						},
						hubLinkedin: {
							description: "Página de LinkedIn conectada vía OAuth Seamless.",
						},
						hubOlx: {
							description: "Chat de anuncios de OLX conectado vía OAuth Seamless.",
						},
						hubMercadoLivre: {
							description: "Preguntas y mensajes de Mercado Libre conectados vía OAuth Seamless.",
						},
						hubTiktok: {
							description: "Cuenta de TikTok conectada vía OAuth Seamless.",
						},
					},
				},
			},
			integrations: {
				title: "Integraciones",
				subtitle: "Conecte servicios externos y automatice flujos de la plataforma.",
				status: {
					connected: "Conectado",
					disconnected: "No configurado",
					comingSoon: "Próximamente",
				},
				actions: {
					configure: "Configurar",
					documentation: "Documentación",
					menuAria: "Acciones de la integración {{name}}",
				},
				metrics: {
					status: "Estado",
					category: "Categoría",
					lastSync: "Última sync",
				},
				modal: {
					title: "Configurar {{name}}",
					cancel: "Cancelar",
					save: "Guardar",
					connectGoogle: "Conectar Google",
					comingSoonToast: "Configuración disponible próximamente.",
					saveSuccess: "Integración configurada con éxito.",
					saveError: "No se pudo guardar la configuración.",
				},
				loadError: "No se pudieron cargar las integraciones.",
				asaas: {
					name: "Asaas",
					description: "Pagos, cobros y Pix integrados al servicio.",
					category: "Pagos",
					modalHint:
						"Ingrese la API Key de su cuenta Asaas para habilitar cobros automáticos.",
					apiKeyLabel: "API Key",
					apiKeyPlaceholder: "Su clave API de Asaas",
				},
				googleCalendar: {
					name: "Google Calendar",
					description: "Sincronice citas y agendas con Google Calendar.",
					category: "Productividad",
					modalHint:
						"Conecte su cuenta Google para sincronizar eventos con la plataforma.",
					connectHint: "Haga clic en Conectar Google para autorizar el acceso a la agenda.",
					connectedHint: "Cuenta Google vinculada a esta empresa. Puede desconectar en cualquier momento.",
					connectSuccess: "Google Calendar conectado con éxito.",
					connectError: "No se pudo conectar Google Calendar.",
					disconnect: "Desconectar",
					disconnecting: "Desconectando…",
					connecting: "Abriendo Google…",
					disconnectSuccess: "Google Calendar desconectado.",
					disconnectError: "No se pudo desconectar Google Calendar.",
				},
			},
			googleAgenda: {
				title: "Google Agenda",
				subtitle: "Vea y gestione eventos de la cuenta Google conectada.",
				connectedAs: "Conectado como {{email}}",
				goToIntegrations: "Ir a Integraciones",
				notConnectedTitle: "Google Agenda no conectada",
				notConnectedHint:
					"Conecte su cuenta Google en Integraciones para ver y gestionar la agenda.",
				prevMonth: "Mes anterior",
				nextMonth: "Mes siguiente",
				today: "Hoy",
				selectedDay: "Eventos del día",
				noEvents: "Ningún evento en este día.",
				newEvent: "Nuevo evento",
				editEvent: "Editar evento",
				summary: "Título",
				description: "Descripción",
				contact: "Contacto",
				contactSearch: "Buscar contacto",
				contactSearchHint: "Escriba al menos 3 caracteres para buscar.",
				contactHint: "Opcional. Vincula este horario a un contacto del sistema.",
				contactEmpty: "Ningún contacto encontrado.",
				contactClear: "Quitar",
				allDay: "Todo el día",
				start: "Inicio",
				end: "Fin",
				save: "Guardar",
				cancel: "Cancelar",
				delete: "Eliminar",
				deleteTitle: "Eliminar evento",
				deleteConfirm: "¿Seguro que desea eliminar este evento?",
				loadError: "No se pudieron cargar los eventos.",
				saveSuccess: "Evento guardado con éxito.",
				saveError: "No se pudo guardar el evento.",
				deleteSuccess: "Evento eliminado.",
				deleteError: "No se pudo eliminar el evento.",
				loading: "Cargando…",
				closeDayPanel: "Cerrar",
				eventSingular: "evento",
				eventPlural: "eventos",
				report: "Informe",
				settings: "Configuración",
				settingsTitle: "Configuración de citas",
				settingsHint:
					"Define la duración de cada horario y cuántos clientes pueden reservar a la misma hora (IA y disponibilidad).",
				slotMinutes: "Duración del horario",
				slotMinutesHint: "Ej.: 60 = horarios de hora en hora",
				slotCapacity: "Clientes por horario",
				slotCapacityHint: "Ej.: 2 = dos clientes a la misma hora",
				minAdvance: "Antelación mínima",
				minAdvanceHint:
					"El cliente no puede reservar a última hora — solo horarios con esta antelación.",
				advanceNone: "Sin restricción",
				advance30m: "30 minutos",
				advance1h: "1 hora",
				advance2h: "2 horas",
				advance3h: "3 horas",
				advance4h: "4 horas",
				advance6h: "6 horas",
				advance12h: "12 horas",
				advance1d: "1 día",
				advance2d: "2 días",
				advance3d: "3 días",
				advance7d: "7 días",
				settingsSave: "Guardar configuración",
				settingsSaveSuccess: "Configuración guardada.",
				settingsSaveError: "No se pudo guardar la configuración.",
				settingsLoadError: "No se pudo cargar la configuración.",
				minutesSuffix: "min",
				notifyEnabled: "Enviar mensaje a la persona agendada",
				notifyHint:
					"Solo se envía si el horario tiene ticket, contacto y teléfono. El mismo mensaje vale para todos.",
				notifyWhen: "Cuándo enviar",
				notifyAtTime: "En el horario de la cita",
				notify30mBefore: "30 minutos antes",
				notify1hBefore: "1 hora antes",
				notify2hBefore: "2 horas antes",
				notify3hBefore: "3 horas antes",
				notify6hBefore: "6 horas antes",
				notify12hBefore: "12 horas antes",
				notify1dBefore: "1 día antes",
				notify30mAfter: "30 minutos después",
				notify1hAfter: "1 hora después",
				notifyConnection: "Conexión de envío",
				notifyConnectionEmpty: "Seleccione la conexión",
				notifyConnectionHint:
					"WhatsApp Business envía plantilla. Las demás conexiones envían texto.",
				notifyType: "Contenido",
				notifyTypeText: "Mensaje de texto",
				notifyTypeTemplate: "Plantilla",
				notifyBody: "Mensaje",
				notifyBodyPlaceholder: "Texto enviado a todas las personas agendadas",
				notifyBodyRequired: "Informe el mensaje de texto.",
				notifyTemplateRequired: "Seleccione una plantilla.",
				notifyTemplateConnection: "Conexión para listar plantillas",
				notifyTemplateConnectionEmpty: "Seleccione una conexión WABA",
				notifyTemplateParam: "Parámetro",
				notifyMedia: "Media de la plantilla",
				notifyMediaUrlPlaceholder: "URL de la media (https://...)",
				notifyMediaRequired: "Adjunte la imagen, el video o el documento de la plantilla.",
				notifyTemplateParamsRequired: "Complete todos los parámetros de la plantilla, incluidos los botones.",
				notifyAttachMedia: "Adjuntar",
				notifyRemoveMedia: "Quitar",
				notifyUploadingMedia: "Enviando...",
			},
			googleAgendaReport: {
				title: "Informe de agendamientos",
				subtitle: "Planilla con todos los eventos de Google Agenda en el período.",
				back: "Volver a la agenda",
				refresh: "Actualizar",
				filter: "Filtrar",
				from: "Desde",
				to: "Hasta",
				loading: "Cargando…",
				empty: "Ningún evento en el período seleccionado.",
				loadError: "No se pudo cargar el informe.",
				notConnected: "Conecte Google Agenda en Integraciones para ver el informe.",
				colTitle: "Título",
				colDescription: "Descripción",
				colStart: "Inicio",
				colEnd: "Fin",
				colTicket: "Ticket",
				colName: "Nombre",
				colPhone: "Teléfono",
				colChannel: "Canal",
				colReferredBy: "Indicación de",
				reminderScheduled: "Mensaje programado",
				colSource: "Quién agendó",
				colStatus: "Estado",
				sourceAi: "IA",
				sourceManual: "Usuario",
				sourceSynced: "Google",
				statusFilter: "Estado",
				statusAll: "Todos",
				statusScheduled: "Agendado",
				statusCompleted: "Concluido",
				statusCancelled: "Cancelado",
				statusPostponed: "Aplazado",
				previewTitle: "Detalle del agendamiento",
				previewSubtitle: "Vista previa de la consulta y cambio de estado",
				close: "Cerrar",
				saveStatus: "Guardar estado",
				saving: "Guardando…",
				statusSaved: "Estado actualizado.",
				statusSaveError: "No se pudo actualizar el estado.",
				changeStatus: "Cambiar estado",
				reason: "Motivo",
				reasonOptional: "Motivo (opcional)",
				reasonPlaceholder: "Informe el motivo",
				changedBy: "Cambiado por",
				openTicket: "Abrir ticket",
				searchName: "Nombre",
				searchTicket: "Ticket",
				searchPhone: "Teléfono",
				searchBookedBy: "Quién agendó",
				clearFilters: "Limpiar filtros",
				countTotal: "Total",
				postponedBy: "Aplazado por",
				newStart: "Nueva fecha/hora de inicio",
				newEnd: "Nueva fecha/hora de fin",
				postponeRequired: "Informe la nueva fecha y hora para aplazar.",
				postponeInvalidRange: "El fin debe ser después del inicio.",
			},
			transactions: {
				title: "Transacciones",
				subtitle: "Asaas · PIX",
				loading: "Cargando transacciones…",
				empty: "No se encontraron transacciones para los filtros seleccionados.",
				integrationMissing: "La integración Asaas aún no está configurada.",
				goToIntegrations: "Configurar integración",
				summary: {
					total: "Total",
					totalHint: "Cobros en el período filtrado",
					pending: "Pendientes",
					pendingHint: "Esperando pago",
					received: "Recibidas",
					receivedHint: "Pagos confirmados",
					receivedMonth: "Recibido en el mes",
					receivedMonthHint: "Suma de valores recibidos en el mes actual",
				},
				filters: {
					search: "Buscar",
					searchPlaceholder: "Contacto, teléfono o ID de pago…",
					period: "Período",
					periodAll: "Todos",
					periodToday: "Hoy",
					periodYesterday: "Ayer",
					period7d: "Últimos 7 días",
					period30d: "Últimos 30 días",
					periodMonth: "Este mes",
					status: "Estado",
					statusAll: "Todos",
				},
				status: {
					pending: "Pendiente",
					received: "Recibido",
				},
				columns: {
					date: "Fecha",
					contact: "Contacto",
					amount: "Valor",
					status: "Estado",
					dueDate: "Vencimiento",
					paidAt: "Pagado en",
					paymentId: "ID de pago",
				},
				pagination: {
					summary: "Mostrando {{from}} a {{to}} de {{total}} transacción(es)",
					prev: "Anterior",
					next: "Siguiente",
					aria: "Paginación de transacciones",
				},
				detail: {
					title: "Detalle de la transacción",
					receivedValue: "Valor recibido",
					pixCode: "Código PIX",
					copyPix: "Copiar código PIX",
					copyPixSuccess: "Código PIX copiado.",
					copyPixError: "No se pudo copiar el código PIX.",
					close: "Cerrar",
					loadError: "No se pudieron cargar los detalles de la transacción.",
				},
			},
			adminAiReports: {
				title: "Informe IA",
				subtitle: "Análisis dinámicos del equipo con inteligencia artificial",
				formTitle: "Armar informe",
				formHint: "Defina período, filtros y enfoques antes de generar el análisis.",
				historyTitle: "Historial",
				historyCount: "{{count}} informe(s)",
				generate: "Generar informe",
				generating: "Generando…",
				generatedSuccess: "Informe generado con éxito.",
				refresh: "Actualizar",
				clear: "Limpiar filtros",
				expand: "Ver",
				collapse: "Ocultar",
				emptyHistory: "Aún no hay informes generados.",
				emptySelection: "Seleccione un informe",
				emptySelectionHint: "Elija un ítem a la izquierda o genere un nuevo análisis.",
				emptyQueues: "No se encontraron sectores.",
				emptyUsers: "No se encontraron agentes.",
				allQueues: "Todos los sectores",
				allUsers: "Todos los agentes",
				selectedCount: "{{count}} seleccionados",
				questionPlaceholder:
					"Ej.: quiero saber quién atiende mejor a los clientes",
				byAuthor: "por {{name}}",
				fields: {
					scope: "Alcance del informe",
					periodType: "Tipo de período",
					date: "Fecha",
					dateFrom: "Desde",
					dateTo: "Hasta",
					queues: "Sectores",
					users: "Agentes",
					ticketId: "ID del ticket",
					contact: "Contacto",
					focuses: "Enfoques del análisis",
					question: "Pregunta libre (opcional)",
				},
				scope: {
					team: "Equipo / período",
					ticket: "Ticket específico",
					contact: "Contacto (últimos 3 tickets)",
				},
				scopeHint: {
					team: "Analiza la operación en el período con filtros de sector y agente.",
					ticket: "Analiza un único ticket leyendo los mensajes de la conversación.",
					contact:
						"Analiza los últimos 3 tickets del contacto y la evolución del lead.",
				},
				ticketPlaceholder: "Ej.: 12345",
				contactPlaceholder: "Buscar por nombre o número…",
				clearContact: "Cambiar contacto",
				searchingContacts: "Buscando contactos…",
				emptyContacts: "No se encontraron contactos.",
				messagesScopeHint:
					"En este alcance los mensajes de los tickets se leen automáticamente.",
				period: {
					day: "Día",
					hour: "Intervalo por hora",
					month: "Mes",
					custom: "Personalizado",
				},
				focuses: {
					sellers: "Desempeño de los agentes",
					talk_time: "Tiempo de conversación",
					quality: "Calidad / CSAT",
					queue_volume: "Volumen por sector",
					complaints: "De qué se quejan más los clientes",
					people_improve: "Cómo mejorar al equipo",
					lead_interest: "Interés del lead",
					lead_classification: "Clasificación del lead",
					lead_helped: "Si la atención ayudó",
					messages: "Leer mensajes de los tickets",
				},
				messagesHint:
					"Incluye una muestra de las conversaciones en el análisis (más lento y consume más tokens).",
				messagesAutoHint:
					"Este enfoque ya activa la lectura de mensajes automáticamente.",
				result: {
					summary: "Resumen",
					insights: "Insights",
					ranking: "Ranking",
					recommendations: "Mejoras del equipo",
				},
				lead: {
					temperature: "Temperatura",
					score: "Score del lead",
					helped: "¿La atención ayudó?",
					classification: "Clasificación",
					nextStep: "Próximo paso",
					objections: "Objeciones principales",
					funnel: "Embudo / alineación",
					tags: "Tags del contacto",
					noObjections: "No se identificaron objeciones claras.",
					noFunnel: "Sin etapa de embudo vinculada.",
					noTags: "Sin tags en este contacto.",
					tempValues: {
						quente: "Caliente",
						morno: "Tibio",
						frio: "Frío",
						indefinido: "Indefinido",
					},
					helpedValues: {
						sim: "Sí",
						parcial: "Parcial",
						nao: "No",
						indefinido: "Indefinido",
					},
					classificationValues: {
						boa: "Buena",
						ruim: "Mala",
						duvidosa: "Dudosa",
						indefinido: "Indefinido",
					},
				},
				errors: {
					needFocus: "Seleccione al menos un enfoque.",
					needDates: "Informe el intervalo de fechas.",
					needTicket: "Informe el ID del ticket.",
					needContact: "Seleccione un contacto.",
				},
			},
			socialComments: {
				title: "Comentarios",
				emptyList: "No se encontraron comentarios.",
				searchPlaceholder: "Buscar comentarios…",
				loading: "Cargando comentarios…",
				loadError: "No se pudieron cargar los comentarios.",
				commentsCount: "{{count}} comentario(s)",
				loadMore:"cargar más",
				loadMoreComments: "Cargar más comentarios",
				loadingMoreComments: "Cargando comentarios…",
				viewComments: "Ver comentarios",
				viewOriginal: "Ver publicación original",
				emptyComments: "No hay comentarios en esta publicación.",

				filters: {
					channel: "Canal",
					status: "Estado",
					all: "Todos",
					facebook: "Facebook",
					instagram: "Instagram",
					tiktok: "TikTok",
					mercadolivre: "Mercado Libre",
					statusAll: "Todos",
				},
				status: {
					open: "Abierto",
					replied: "Respondido",
				},
				actions: {
					reply: "Responder",
					markReplied: "Marcar respondido",
					reopen: "Reabrir",
				},
				mock: {
					banner: "Datos ficticios para demostración — no reflejan comentarios reales.",
				},
				reply: {
					placeholder: "Escriba su respuesta…",
					success: "Respuesta enviada (simulación local).",
				},
			},
			permissionModal: {
				title: "Acción no permitida",
				content: "No tienes permiso para realizar la acción.",
			},
			whatsappModal: {
				title: {
					add: "Agrega Conexión",
					edit: "Edita Conexión",
				},
				form: {
					name: "Nombre de la conexión",
					default: "Por Defecto",
					channel: "Canal",
					farewellMessage: "Mensaje de despedida",
					whatsapp: "WhatsApp",
					facebook: "Facebook",
					telegram: "Telegram",
					instagram: "Instagram",
					whatsappcloud: "WhatsApp API",
					connectionInfo: "Información de conexión",
					connectionInfoHint: "Fechas de creación y última actualización de la conexión.",
					createdAt: "Creado el",
					updatedAt: "Actualizado el",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "WhatsApp guardado satisfactoriamente.",
			},
			qrCode: {
				title: "Para conectarse a Notificarme:",
				firstPoint: "Abre WhatsApp en tu móvil.",
				secondPoint: {
					partOne: "Toque en ",
					moreOptions: "Mas opciones ",
					partTwo: " o ",
					configurations: "Ajustes ",
					partThree: "y seleccione Dispositivos conectados.",
				},
				thirdPoint: "Presiona Conectar un dispositivo.",
				fourthPoint:
					"Apunta tu celular a esta pantalla para capturar el código.",
				message: "Lea el QRCode para iniciar sesión",
				waiting: "Esperando el QR Code...",
			},
			contacts: {
				title: "Contactos",
				subtitle: "Administración",
				listTitle: "Lista de contactos",
				toasts: {
					deleted: "¡Contacto borrado satisfactoriamente!",
					deletedSelected: "Contactos seleccionados eliminados correctamente.",
				},
				selectAll: "Seleccionar todos en la lista",
				selectRow: "Seleccionar {{name}}",
				selectedCount: "{{count}} seleccionado(s)",
				searchPlaceholder: "Buscar nombre, correo o número...",
				filterTagsPlaceholder: "Filtrar por etiquetas",
				filterTagsSelectedCount: "{{count}} etiquetas seleccionadas",
				filterTagsClear: "Limpiar selección",
				empty: "No se encontraron contactos.",
				emptyHint: "Pruebe con otro término o filtro.",
				pagination: {
					label: "Paginación",
					showing: "Mostrando {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Siguiente",
				},
				confirmationModal: {
					deleteTitle: "Borrar",
					importTitlte: "Importar contactos",
					deleteMessage:
						"¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
					deleteSelectedTitle: "¿Eliminar contactos seleccionados?",
					deleteSelectedMessage:
						"Se eliminarán {{count}} contacto(s). Todos los tickets relacionados se perderán.",
					importMessage:
						"¿Quieres importar todos los contactos desde tu teléfono?",
				},
				buttons: {
					import: "Importar",
					export: "Exportar",
					add: "Agregar contacto",
					deleteSelected: "Eliminar seleccionados",
					chat: "Conversar",
					edit: "Editar",
					delete: "Eliminar",
				},
				table: {
					name: "Nombre",
					tags: "Etiquetas",
					whatsapp: "WhatsApp",
					email: "Correo electrónico",
					company: "Compañía",
					actions: "Acciones",
				},
			},
			contactModal: {
				title: {
					add: "Agregar contacto",
					edit: "Editar contacto",
				},
				form: {
					connection: "Conexión",
					mainInfo: "Detalles del contacto",
					extraInfo: "Información adicional",
					name: "Nombre",
					number: "Número de Whatsapp",
					numberHint: "Código de país (55 para Brasil) y número con código de área (ej.: 13912344321).",
					ddi: "Código de país",
					ddiRequired: "Ingrese el código de país (ej.: 55).",
					numberBrInvalid: "Ingrese código de área + número (10 u 11 dígitos, ej.: 13912344321).",
					numberInvalid: "Número inválido para el código de país informado.",
					numberDigitsOnly: "Ingrese solo números.",
					email: "Correo Electrónico",
					company: "Compañía",
					extraName: "Nombre del Campo",
					extraValue: "Valor",
				},
				buttons: {
					addExtraInfo: "Agregar información",
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Contacto guardado satisfactoriamente.",
			},
			contactsImportModal: {
				title: "Importar contactos",
				success: "Contactos importados con éxito.",
				steps: {
					upload: "Subir archivo",
					mapping: "Mapeo de campos",
					import: "Importar",
				},
				buttons: {
					cancel: "Cancelar",
					back: "Volver",
					continue: "Continuar",
					import: "Importar",
				},
				stepOne: {
					intro: "Sube un archivo CSV con los contactos que deseas agregar.",
					hint: "Si tu archivo está en otro formato, ábrelo en Excel y expórtalo como CSV.",
					downloadSample: "Descargar un archivo CSV de ejemplo",
					filePlaceholder: "Insertar archivo CSV",
					browse: "Buscar",
					selectedCount: "{{count}} contactos seleccionados",
					warning: "Límite de contactos CSV: 1.000"
				},
				stepTwo: {
					intro: "Selecciona las variables correspondientes a las columnas del CSV.",
					name: "Nombre del contacto (obligatorio)",
					number: "Número del contacto (obligatorio)",
					email: "Correo del contacto",
					select: "Seleccionar columna",
					none: "Ninguno",
				},
				stepThree: {
					intro: "Confirma el mapeo de campos con la muestra siguiente.",
				},
			},
			contactsExportModal: {
				titleExporting: "Exportando contactos",
				titleDone: "Operación completada",
				exporting: "Espere mientras se genera el archivo…",
				done: "Contactos exportados: {{count}}",
				close: "Cerrar",
			},
			bulkMessaging: {
				title: "Envío masivo",
				subtitle: "Gestione campañas de mensajes en lote",
				listTitle: "Campañas",
				empty: "No hay campañas registradas.",
				confirmDeleteTitle: "¿Eliminar envío masivo?",
				buttons: { add: "Agregar envío masivo" },
				toasts: { deleted: "¡Envío masivo eliminado!", updated: "¡Envío masivo actualizado!" },
				table: {
					protocol: "Protocolo",
					name: "Nombre",
					sendDate: "Fecha de envío",
					estimatedEnd: "Fin previsto",
					status: "Estado",
					actions: "Acciones",
				},
				status: {
					stopped: "Pausado",
					running: "En ejecución",
					unstarted: "No iniciado",
					cancelled: "Cancelado",
					complete: "Completo",
				},
				actions: {
					edit: "Editar",
					start: "Iniciar",
					pause: "Pausar",
					resume: "Continuar",
					resendAll: "Reenviar todos",
					resendAllHint: "Reencola solo contactos sin confirmación de envío",
					resendFailed: "Reenviar {{count}} fallidos",
					loading: "Cargando…",
					details: "Detalles",
					duplicate: "Duplicar",
					delete: "Eliminar",
				},
				infoModal: {
					title: "Informe de envíos",
					close: "Cerrar",
					name: "Nombre",
					contact: "Contacto",
					status: "Status",
					attempts: "Intentos",
					sent: "Enviado",
					notSent: "Falló",
					pending: "Pendiente",
					summarySuccess: "Éxito",
					summaryFailed: "Fallos",
					summaryPending: "Pendientes",
					tabAll: "Todos",
					tabSuccess: "Enviados",
					tabFailed: "Fallos",
					tabPending: "Pendientes",
					errorReason: "Motivo",
					empty: "No hay contactos en este envío.",
				},
				variablesModal: {
					title: "Variables de mensaje",
					hint: "Haga clic en una variable para insertarla en el mensaje.",
					close: "Cerrar",
				},
				modal: {
					titleAdd: "Crear envío masivo de mensajes",
					titleEdit: "Editar envío masivo de mensajes",
					steps: {
						campaign: "Configurar campaña",
						contacts: "Seleccionar envíos",
						review: "Revisar datos",
					},
					back: "Volver",
					continue: "Continuar",
					finish: "Finalizar",
					reset: "Reiniciar",
					allStepsDone: "Todas las etapas fueron completadas.",
				},
				wizard: {
					pageTitleAdd: "Nueva campaña",
					pageTitleEdit: "Editar campaña",
					breadcrumbList: "Envío masivo",
					backToList: "Lista de campañas",
					previousStep: "Etapa anterior",
					contactsStep: {
						intro: "Elija cómo agregar destinatarios: seleccione contactos registrados o importe una lista CSV.",
						tabRegistered: "Contactos registrados",
						tabImport: "Importar lista",
						panelIncluded: "Contactos en la campaña",
						panelAvailable: "Contactos disponibles",
						selectHint: "Marque los contactos y haga clic en agregar.",
						importHint: "Suba un archivo .csv, .xlsx o .xls con las columnas name y number. Solo se importarán números de teléfono válidos.",
						downloadSample: "Descargar archivo de ejemplo",
						filePlaceholder: "Ningún archivo seleccionado",
						browse: "Seleccionar archivo",
						addSelected: "Agregar a la campaña ({{count}})",
						selectedTitle: "Contactos de la campaña ({{count}})",
						manualTitle: "O agregue un número suelto",
						contactName: "Nombre del contacto",
						contactNumber: "Número (con código de país)",
						numberExample: "Ejemplo: 5527998851972",
						numberExampleShort: "5527998851972",
						numberInvalid: "Use 12 o 13 dígitos con DDI",
						addManual: "Agregar",
						removeSelected: "Eliminar seleccionados ({{count}})",
						searchedCount: "Encontrados: {{count}}",
						searchPlaceholder: "Nombre o número",
						searchInputPlaceholder: "Buscar por nombre o número",
						clearSearch: "Limpiar búsqueda",
						searchTags: "Etiquetas",
						searchButton: "Buscar",
						importEmpty: "El archivo está vacío o no es válido.",
						importInvalidColumns: "El archivo debe tener columnas name y number (o nombre y número).",
						importUnsupportedType: "Formato no soportado. Use .csv, .xlsx o .xls.",
						importNoRows: "No se encontraron contactos válidos en el archivo.",
						importSuccess: "{{count}} contacto(s) importado(s) a la campaña.",
						importPartialSuccess:
							"{{valid}} contacto(s) importado(s). {{invalid}} fila(s) omitida(s) por error.",
						importRejectedTitle: "{{count}} fila(s) no importada(s)",
						importRejectedLine: "Fila",
						importRejectedReason: "Motivo",
						importRejectReasons: {
							emptyName: "Nombre vacío",
							emptyNumber: "Número vacío",
							invalidNumber: "No es un número de teléfono válido",
							duplicate: "Número duplicado en el archivo",
							alreadyInCampaign: "Ya está en la campaña",
						},
						importError: "No se pudo leer el archivo.",
						importAddedHint: "{{count}} contacto(s) agregado(s). Véalo en la columna de la derecha.",
						emptyCampaign: "Aún no hay contactos en la campaña.",
						emptyAvailable: "No se encontraron contactos. Ajuste la búsqueda o etiquetas.",
						loadingContacts: "Cargando contactos...",
					},
				},
			},
			quickAnswersModal: {
				title: {
					add: "Agregar respuesta rápida",
					edit: "Editar respuesta rápida",
				},
				form: {
					shortcut: "Atajo",
					message: "Mensaje",
					attachImage: "Adjuntar imagen",
					removeImage: "Quitar imagen",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Respuesta rápida guardada correctamente.",
			},
			queueModal: {
				title: {
					add: "Agregar cola",
					edit: "Editar cola",
				},
				notification: {
					title: "¡Sector guardado con éxito!",
					chatbotAdded: "¡Chatbot vinculado al sector con éxito!",
					saveBeforeChatbot: "Guarde el sector antes de vincular el chatbot.",
				},
				form: {
					name: "Nombre",
					color: "Color",
					greetingMessage: "Mensaje de saludo",
					startWork: "Apertura",
					endWork: "Cierre",
					absenceMessage: "Mensaje de ausencia",
				},
				buttons: {
					okAdd: "Añadir",
					okEdit: "Ahorrar",
					cancel: "Cancelar",
				},
			},
			userModal: {
				title: {
					add: "Agregar usuario",
					edit: "Editar usuario",
				},
				form: {
					name: "Nombre",
					email: "Correo Electrónico",
					password: "Contraseña",
					whatsapp: "Conexión predeterminada",
					profile: "Perfil",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Usuario guardado satisfactoriamente.",
			},
			chat: {
				noTicketMessage: "Selecciona un ticket para empezar a chatear.",
				noChatDescription:
					"Envía y recibe mensajes sin tener que mantener tu teléfono conectado a Internet",
				noChatDescriptionText:
					`Usa ${process.env.REACT_APP_NOME} en tantas computadoras como quieras y en un celular al mismo tiempo.`,
				layout: {
					tryNewExperience: "Nueva experiencia",
					tryNewExperienceSub: "Diseño moderno del chat",
					newExperienceBadge: "Nuevo",
					newExperienceActive: "Nueva experiencia activa",
					backToClassicShort: "Volver",
					backToClassic: "Volver al diseño clásico",
					classicLayoutRailLabel: "Diseño clásico",
					toggleHint:
						"Solo cambia el aspecto del chat. El modo de lista de la empresa sigue en Configuración.",
					switched: "Diseño del chat actualizado.",
					chatsTitle: "Chats",
					openSection: "Tickets abiertos",
					backToList: "Chats",
					selectConversationHint: "Selecciona una conversa en la lista.",
					searchPlaceholder: "Buscar o iniciar una conversación",
					newConversation: "Nueva conversación",
					recentChats: "Chats recientes",
					allConversations: "Todas las conversaciones",
					pendingSection: "Tickets pendientes",
					closedSection: "Cerradas",
					statusSection: "Estado",
					filters: "Filtros",
					filterAll: "Todo",
					filterConection: "Canales",
					filterConectionEmpty: "No se encontró ningún canal.",
					selectFilterChannel: "Seleccionar canales",
					filterUnread: "No leídos",
					filterUnreadWithCount: "No leídos, {{count}} mensajes no leídos",
					filterGroups: "Grupos",
					filterSort: "Ordenación",
					filterSortAsc: "Más antiguos primero",
					filterSortDesc: "Más recientes primero",
					filterQueues: "Sectores",
					filterTags: "Etiquetas",
					filterQueuesEmpty: "No hay sectores disponibles",
					filterTagsEmpty: "No hay etiquetas disponibles",
					filterTagsSearch: "Buscar etiquetas...",
					filterTagsPlaceholder: "Seleccionar etiquetas",
					filterTagsNoResults: "Ninguna etiqueta encontrada",
					filterClearAll: "Limpiar",
					filterApply: "Aplicar",
					salesFunnel: "Embudo de ventas",
					loadMore: "Cargar más",
					loadingMore: "Cargando...",
				},
			},
			ticketsManager: {
				buttons: {
					newTicket: "Nuevo",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Linhas",
			},
			tickets: {
				toasts: {
					deleted: "El ticket en el que estabas ha sido borrado.",
				},
				notification: {
					message: "Mensaje de",
				},
				tabs: {
					open: { title: "Bandeja" },
					closed: { title: "Resueltos" },
					search: { title: "Buscar" },
				},
				search: {
					placeholder: "Buscar tickets y mensajes.",
					recentTitle: "Recientes",
					recentClear: "Borrar todo",
					recentRemove: "Quitar búsqueda",
				},
				buttons: {
					showAll: "Todos",
				},
			},
			templateOnlyBar: {
				message:
					"Fuera de la ventana de 24 horas de Meta. Envíe una plantilla para continuar la conversación.",
			},
			transferTicketModal: {
				title: "Transferir Ticket",
				fieldLabel: "Escriba para buscar usuarios",
				fieldQueueLabel: "Transferir a la cola",
				fieldConnectionLabel: "Transferir to conexión",
				fieldQueuePlaceholder: "Seleccione una cola",
				fieldConnectionPlaceholder: "Seleccione una conexión",
				noOptions: "No se encontraron usuarios con ese nombre",
				buttons: {
					ok: "Transferir",
					cancel: "Cancelar",
				},
			},
			statusList: {
				title: "Estado de WhatsApp",
				subtitle: "Toca un contacto para ver su actualización de estado.",
				viewStatus: "Ver estado",
				published: "Estado publicado",
				unavailable: "Medio del estado no disponible",
				emptyTitle: "No hay estados por ahora",
				emptyMessage:
					"Cuando los contactos publiquen estados, aparecerán aquí. Activa “Estado del perfil” en Configuración.",
			},
			ticketsList: {
				pendingHeader: "Cola",
				assignedHeader: "Trabajando en",
				noTicketsTitle: "¡Nada acá!",
				connectionTitle: "Conexión que se está utilizando actualmente.",
				noTicketsMessage:
					"No se encontraron tickets con este estado o término de búsqueda",
				items: {
					queueless: "Sin sector",
					accept: "Aceptar",
					spy: "Espía",
					close: "cerca",
					reopen: "Reabrir",
				},
				buttons: {
					accept: "Responder",
					acceptBeforeBot: "Aceptar",
					start: "empezar",
					cancel: "Cancelar",
				},
				acceptModal: {
					title: "Aceptar chat",
					queue: "Seleccionar sector",
				},
			},
			newTicketModal: {
				title: "Crear Ticket",
				fieldLabel: "Escribe para buscar un contacto",
				add: "Añadir",
				buttons: {
					ok: "Guardar",
					cancel: "Cancelar",
				},
			},
			master: {
				layout: {
					title: "Panel Master",
					subtitle: "Administración del sistema",
					toggleMenu: "Alternar menú",
					closeMenu: "Cerrar menú",
					toggleTheme: "Alternar tema",
					searchPlaceholder: "Buscar...",
					ModalIa:"Gerente de IA"
				},
				nav: {
					dashboard: "Dashboard",
					companies: "Empresas",
					plans: "Planes",
					addons: "Compras sueltas",
					coupons: "Cupones",
					finance: "Financiero",
					system: "Análisis del servidor",
					documents: "Informativos",
					searchUsers: "Usuarios por empresa",
					scheduleLogs: "Logs de agendamientos",
					bulkMessagingLogs: "Logs envío masivo",
					sectionOverview: "General",
					sectionCommercial: "Comercial",
					sectionSystem: "Sistema",
					sectionLogs: "Logs",
				},
				documents: {
					pageTitle: "Informativos",
					pageSubtitle: "Avisos, Meta, actualizaciones y eventos para las empresas",
				},
				plans: {
					pageTitle: "Planes",
					pageSubtitle: "Catálogo de planes del sistema",
					listTitle: "Planes registrados",
					countLabel: "registros",
					loading: "Cargando planes...",
					empty: "Ningún plan registrado",
					emptyHint: "Cree el primer plan para disponibilizarlo en el catálogo.",
					create: "Nuevo plan",
					createTitle: "Nuevo plan",
					editTitle: "Editar plan",
					edit: "Editar",
					delete: "Eliminar",
					close: "Cerrar",
					cancel: "Cancelar",
					save: "Guardar",
					saving: "Guardando...",
					fieldName: "Nombre",
					fieldPriceMonthly: "Precio mensual",
					fieldPriceQuarterly: "Precio trimestral",
					fieldPriceSemiannual: "Precio semestral",
					fieldPriceAnnual: "Precio anual",
					fieldMonthlyTokens: "Tokens mensuales",
					fieldActive: "Activo en el catálogo",
					pricesHint: "Defina el precio de cada ciclo de cobro en el mismo plan.",
					colName: "Nombre",
					colPriceMonthly: "Mensual",
					colPriceQuarterly: "Trimestral",
					colPriceSemiannual: "Semestral",
					colPriceAnnual: "Anual",
					colMonthlyTokens: "Tokens/mes",
					tokensShort: "tokens/mes",
					perMonth: "por mes",
					statTotal: "Total de planes",
					statActive: "Planes activos",
					statInactive: "Planes inactivos",
					colStatus: "Estado",
					colActions: "Acciones",
					confirmDelete: "¿Eliminar el plan \"{{name}}\"?",
					confirmDeleteMessage: "Si el plan está vinculado a empresas, solo se desactivará.",
					toastCreated: "Plan creado.",
					toastUpdated: "Plan actualizado.",
					toastDeleted: "Plan eliminado.",
					toastDisabled: "Plan desactivado (hay empresas vinculadas).",
				},
				addons: {
					pageTitle: "Compras sueltas",
					pageSubtitle: "Catálogo de paquetes adicionales (tokens y otros ítems)",
					listTitle: "Paquetes registrados",
					countLabel: "registros",
					loading: "Cargando paquetes...",
					empty: "Ningún paquete registrado",
					emptyHint: "Cree el primer paquete de tokens adicionales.",
					create: "Nuevo paquete",
					createTitle: "Nuevo paquete",
					editTitle: "Editar paquete",
					edit: "Editar",
					delete: "Eliminar",
					cancel: "Cancelar",
					save: "Guardar",
					saving: "Guardando...",
					fieldName: "Nombre",
					fieldQuantity: "Cantidad de tokens",
					fieldPrice: "Precio",
					fieldActive: "Activo en el catálogo",
					formHint: "Paquete de tokens adicionales sin vencimiento.",
					typeTokens: "Tokens",
					tokensUnit: "tokens",
					statTotal: "Total de paquetes",
					statActive: "Paquetes activos",
					statInactive: "Paquetes inactivos",
					confirmDelete: "¿Eliminar el paquete \"{{name}}\"?",
					confirmDeleteMessage: "Si el paquete está vinculado a compras, solo se desactivará.",
					toastCreated: "Paquete creado.",
					toastUpdated: "Paquete actualizado.",
					toastDeleted: "Paquete eliminado.",
					toastDisabled: "Paquete desactivado (hay compras vinculadas).",
				},
				coupons: {
					pageTitle: "Cupones",
					pageSubtitle: "Cupones de descuento para compras y suscripciones",
					listTitle: "Cupones registrados",
					countLabel: "registros",
					loading: "Cargando cupones...",
					empty: "Ningún cupón registrado",
					emptyHint: "Cree el primer cupón de descuento.",
					create: "Nuevo cupón",
					createTitle: "Nuevo cupón",
					editTitle: "Editar cupón",
					edit: "Editar",
					delete: "Eliminar",
					cancel: "Cancelar",
					save: "Guardar",
					saving: "Guardando...",
					fieldName: "Código",
					fieldDiscountType: "Tipo de descuento",
					fieldDiscountValue: "Valor del descuento",
					fieldExpiresAt: "Vencimiento",
					fieldLifetime: "Vitalicio (sin vencimiento)",
					fieldEmailRef: "Email restringido",
					fieldActive: "Activo en el catálogo",
					formHint: "Código único. Deje el email vacío para uso general.",
					emailHint: "Opcional. Si se completa, el cupón solo aplica a este email.",
					typePercentage: "Porcentaje",
					typeFixed: "Valor fijo",
					noExpiry: "Vitalicio",
					anyEmail: "Cualquier email",
					statTotal: "Total de cupones",
					statActive: "Cupones activos",
					statInactive: "Cupones inactivos",
					confirmDelete: "¿Eliminar el cupón \"{{name}}\"?",
					confirmDeleteMessage: "Si el cupón está vinculado a planes, solo se desactivará.",
					toastCreated: "Cupón creado.",
					toastUpdated: "Cupón actualizado.",
					toastDeleted: "Cupón eliminado.",
					toastDisabled: "Cupón desactivado (hay planes vinculados).",
				},
				finance: {
					pageTitle: "Financiero",
					pageSubtitle: "Compras, suscripciones y uso de cupones",
					periodPreset: "Período",
					period30: "Últimos 30 días",
					period90: "Últimos 90 días",
					periodMonth: "Mes actual",
					periodAll: "Todo el período",
					periodCustom: "Personalizado",
					from: "Desde",
					to: "Hasta",
					kpiRevenuePaid: "Ingresos pagos (tokens)",
					kpiRevenuePending: "Pendiente (tokens)",
					kpiSubsActive: "Suscripciones activas",
					kpiSubsWithCoupon: "Suscripciones con cupón",
					revenueChart: "Ingresos pagos por mes",
					noChartData: "Sin datos de ingresos en el período.",
					purchasesByStatus: "Resumen",
					statusPaid: "Pago",
					statusPending: "Pendiente",
					statusCanceled: "Cancelado",
					statusActive: "Activo",
					statusExpired: "Expirado",
					statusInactive: "Inactivo",
					subsCanceled: "Suscripciones canceladas",
					subsExpired: "Suscripciones expiradas",
					tab: {
						purchases: "Compras sueltas",
						subscriptions: "Suscripciones",
						coupons: "Cupones",
					},
					allStatuses: "Todos los estados",
					allCoupons: "Todas las suscripciones",
					onlyWithCoupon: "Solo con cupón",
					emptyPurchases: "No se encontraron compras.",
					emptySubscriptions: "No se encontraron suscripciones.",
					emptyCoupons: "No se encontró uso de cupones.",
					colCompany: "Empresa",
					colAddon: "Paquete",
					colTotal: "Total",
					colDiscount: "Descuento",
					colStatus: "Estado",
					colPaymentId: "Payment ID",
					colDate: "Fecha",
					colPlan: "Plan",
					colTokens: "Tokens usados",
					colCoupon: "Cupón",
					colStarted: "Inicio",
					colExpires: "Vence",
					colUsage: "Usos",
					colLastUsed: "Último uso",
					records: "registros",
					prev: "Anterior",
					next: "Siguiente",
				},
				scheduleLogs: {
					pageTitle: "Logs de agendamientos",
					pageSubtitle: "Errores y avisos del envío programado (Go/Redis)",
					trackPageTitle: "Ruta del agendamiento",
					trackBreadcrumb: "Ruta",
					listTitle: "Registros de error y aviso",
					records: "registros",
					allCompanies: "Todas las empresas",
					filterScheduleId: "ID del agendamiento",
					allLevels: "Todos los niveles",
					levelError: "Error",
					levelWarn: "Aviso",
					allEvents: "Todos los eventos",
					searchMessage: "Buscar en el mensaje...",
					empty: "No se encontraron logs con los filtros actuales.",
					colDate: "Fecha/hora",
					colSchedule: "Agendamiento",
					colCompany: "Empresa",
					colEvent: "Evento",
					colLevel: "Nivel",
					colMessage: "Mensaje",
					colStatus: "Estado",
					colActions: "Acciones",
					viewTrack: "Ver ruta",
					showing: "Mostrando {{start}}–{{end}} de {{total}}",
					prev: "Anterior",
					next: "Siguiente",
					trackTitle: "Ruta de ejecución",
					scheduleId: "Agendamiento",
					close: "Cerrar",
					sendAt: "Enviar en",
					contactId: "Contacto",
					lastError: "Último error",
					noLogsForSchedule: "No hay logs registrados para este agendamiento.",
					traceTitle: "Pasos hasta la falla",
					channel: "Canal",
				},
				bulkMessagingLogs: {
					pageTitle: "Logs de envío masivo",
					pageSubtitle: "Errores y avisos del envío masivo (Go/Asynq)",
					trackPageTitle: "Ruta de la campaña",
					trackBreadcrumb: "Ruta",
					listTitle: "Registros de error y aviso",
					records: "registros",
					allCompanies: "Todas las empresas",
					filterBulkId: "ID de campaña",
					filterContactNumber: "Número del contacto",
					allLevels: "Todos los niveles",
					levelError: "Error",
					levelWarn: "Aviso",
					allEvents: "Todos los eventos",
					searchMessage: "Buscar en el mensaje...",
					empty: "No se encontraron logs con los filtros actuales.",
					colDate: "Fecha/hora",
					colBulk: "Campaña",
					colNumber: "Número",
					colCompany: "Empresa",
					colEvent: "Evento",
					colLevel: "Nivel",
					colMessage: "Mensaje",
					colStatus: "Estado",
					colName: "Nombre",
					colActions: "Acciones",
					viewTrack: "Ver ruta",
					showing: "Mostrando {{start}}–{{end}} de {{total}}",
					prev: "Anterior",
					next: "Siguiente",
					trackTitle: "Ruta de ejecución",
					bulkId: "Campaña",
					close: "Cerrar",
					protocol: "Protocolo",
					contactNumber: "Número",
					lastError: "Último error",
					noLogsForBulk: "No hay logs registrados para esta campaña.",
					traceTitle: "Pasos hasta la falla",
					channel: "Canal",
					statsSuccess: "Enviados",
					statsFailed: "Fallos",
					statsPending: "Pendientes",
				},
				system: {
					cpu: "Procesador (CPU)",
					ram: "Memoria (RAM)",
					storage: "Almacenamiento",
					uptime: "Tiempo activo",
					free: "Libre",
					usage: "Uso",
					cores: "núcleos",
					volumes: "Volúmenes de disco",
					volumeCount: "volúmenes",
					mount: "Montaje",
					fs: "Sistema de archivos",
					capacity: "Capacidad",
					loading: "Cargando métricas del servidor...",
					loadError: "Error al cargar la información del sistema.",
					retry: "Reintentar",
					refreshing: "Actualizando",
				},
				dashboard: {
					totalCompanies: "Total de empresas",
					activeCompanies: "Empresas activas",
					totalUsers: "Total de usuarios",
					totalConnections: "Total de conexiones",
					active: "Activas",
					inactive: "Inactivas",
					registrationsChart: "Registros por mes",
					statusChart: "Estado de empresas",
					topCompaniesChart: "Top empresas por usuarios",
					noChartData: "Sin datos para mostrar",
					systemCardTitle: "Salud del servidor",
					systemCardLink: "Ver análisis completo",
					memory: "Memoria",
					disk: "Disco",
				},
				pages: {
					dashboardTitle: "Dashboard",
					dashboardSubtitle: "Resumen del sistema y métricas de empresas",
					companiesTitle: "Empresas",
					statusActive: "Activo",
					statusInactive: "Inactivo",
					editCompany: "Editar",
					companiesListTitle: "Empresas registradas",
					companiesListSubtitle: "Todas las empresas del sistema",
					companiesCountLabel: "registros",
					companiesSearchPlaceholder: "Buscar por nombre, documento o ID",
					companiesFilterAll: "Todos los estados",
					companiesShowing: "Mostrando {{start}}–{{end}} de {{total}} resultados",
					colCompany: "Empresa",
					colUsers: "Usuarios",
					colLimit: "Límite",
					colConnections: "Conexiones",
					colContractDueDate: "Vencimiento",
					colContractValue: "Valor",
					colContractDetails: "Detalles del contrato",
					colStatus: "Estado",
					colCreated: "Registro",
					colActions: "Acciones",
					activate: "Activar",
					deactivate: "Desactivar",
					masterCompanyLocked: "La empresa Master del sistema no puede desactivarse.",
					masterCompanyBadge: "Sistema",
					systemTitle: "Análisis del sistema",
					systemSubtitle: "CPU, memoria y almacenamiento del servidor · actualización automática cada 30s",
					systemLastUpdate: "Última actualización",
					systemRefresh: "Actualizar ahora",
					searchUsersTitle: "Usuarios por empresa",
					searchUsersSubtitle: "Seleccione una empresa para listar los usuarios",
					searchUsersCompanyLabel: "Empresa",
					searchUsersSelectCompany: "Seleccione una empresa",
					searchUsersSearchLabel: "Buscar",
					searchUsersPlaceholder: "Nombre, correo o ID...",
					searchUsersListTitle: "Usuarios de la empresa",
					searchUsersCountLabel: "registros",
					searchUsersStatTotal: "Usuarios encontrados",
					searchUsersNoCompany: "Ninguna empresa seleccionada",
					searchUsersNoCompanyHint: "Elija una empresa arriba para ver los usuarios.",
					searchUsersLoading: "Cargando usuarios...",
					searchUsersEmpty: "Ningún usuario encontrado",
					searchUsersEmptyHint: "Pruebe otro término de búsqueda.",
					searchUsersShowing: "Mostrando {{start}}–{{end}} de {{total}}",
					colUser: "Usuario",
					colEmail: "Correo",
					colProfile: "Perfil",
					companyOwner: "Responsable",
					profile_user: "Agente",
					profile_admin: "Administrador",
					profile_master: "Master",
					editCompanyTitle: "Editar empresa",
					contractSectionTitle: "Contrato",
					contractSectionHint: "Observaciones comerciales y fecha de vencimiento completadas manualmente.",
					contractDetailsLabel: "Detalles del contrato",
					contractDetailsHint: "Registre lo acordado con el cliente (plan, condiciones, observaciones).",
					contractDetailsPlaceholder: "Ej.: Plan anual con 5 usuarios y soporte prioritario...",
					contractDueDateLabel: "Fecha de vencimiento",
					contractDueDateHint: "Fecha en que vence el contrato o la licencia.",
					contractValueLabel: "Valor del contrato",
					contractValueHint: "Valor acordado con el cliente (informativo, carga manual).",
					contractValuePlaceholder: "Ej.: 1500.00",
					viewContractDetails: "Ver detalles del contrato",
					contractDetailsReadOnlyLabel: "Observaciones del contrato",
					noContractDetails: "Ningún detalle registrado para esta empresa.",
					loading: "Cargando...",
					loadingCompany: "Cargando datos de la empresa...",
					saving: "Guardando...",
					passwordOptional: "Deje en blanco para no cambiar la contraseña.",
					loadingCompanies: "Cargando empresas...",
					noCompanies: "Ninguna empresa registrada",
					noCompaniesHint: "Las empresas aparecerán aquí cuando se creen.",
					viewCompany: "Ver empresa",
					viewCompanySubtitle: "Datos y contacto",
					viewPlanNameLabel: "Plan",
					previous: "Anterior",
					next: "Siguiente",
					pageOf: "Página {{page}} de {{total}}",
					companiesRange: "{{start}}–{{end}} de {{total}} empresas",
				},
				editCompany: {
					planSectionTitle: "Plan / tokens",
					planSectionHint:
						"Defina un plan del catálogo o uno personalizado y la cuota mensual de tokens. El valor cobrado está en Valor del contrato.",
					planModeLabel: "Modo",
					planModeCatalog: "Catálogo",
					planModeCustom: "Personalizado",
					planCatalogLabel: "Plan del catálogo",
					planCatalogPlaceholder: "Seleccione un plan",
					planCustomNameLabel: "Nombre del plan",
					planCustomNamePlaceholder: "Ej.: Plan corporativo custom",
					planMonthlyTokensLabel: "Cuota mensual de tokens",
					planMonthlyTokensHint: "Puede sobrescribir la cuota predeterminada del plan del catálogo.",
					planExpiresAtLabel: "Validez del plan",
					planExpiresAtHint: "Opcional. Déjelo vacío si no hay vencimiento.",
					planStatusLabel: "Estado",
					planStatusActive: "Activo",
					planStatusCanceled: "Cancelado",
					planStatusExpired: "Expirado",
					planUsedTokens: "Tokens usados",
					planExtraTokens: "Tokens extra",
					planRemainingTokens: "Tokens restantes",
					planNoActive: "Ningún plan activo. Guarde para crear uno.",
					planSave: "Guardar plan",
					planSaving: "Guardando plan...",
					planSaved: "Plan actualizado con éxito.",
					planLoadError: "No se pudieron cargar los planes del catálogo.",
					planCustomNameRequired: "Indique el nombre del plan personalizado (mín. 2 caracteres).",
					companyAndPlanSaved: "Empresa y plan actualizados con éxito.",
				},
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Conexiones",
					tickets: "Conversaciones",
					socialComments: "Comentarios",
					contacts: "Contactos",
					quickAnswers: "Respuestas rápidas",
					documentation: "Informativos",
					queues: "Sectores",
					tags: "Tags",
					schedules: "Horarios",
					googleAgenda: "Google Agenda",
					administration: "Administración",
					followUp: "Follow-up",
					users: "Usuarios",
					settings: "Configuración",
					api: "uso de la API",
					apidocs: "Documentación",
					apititle: "API",
					apikey: "API Key",
					token: "Token",
					salesFunnel: "Embudo de ventas",
				},
				appBar: {
					user: {
						profile: "Perfil",
						logout: "Cerrar Sesión",
					},
				},
			},
			notifications: {
				noTickets: "Sin notificaciones.",
			},
			layout: {
				topbarSearch: {
					placeholder: "Buscar páginas, contactos y conversaciones...",
					pages: "Páginas",
					contacts: "Contactos",
					tickets: "Conversaciones",
					noResults: "No se encontraron resultados.",
					loading: "Buscando...",
					systemVersion: "Versión del sistema",
				},
			},
			followUp: {
				title: "Follow-up",
				adminSubtitle: "Administración",
				listTitle: "Reglas por sector",
				listHint: "Si el último mensaje es tuyo (agente) y el cliente no responde, el sistema envía el texto y después aplica la acción.",
				loading: "Cargando sectores…",
				empty: "No se encontraron sectores.",
				enabled: "Activo",
				disabled: "Inactivo",
				modalTitle: "Configurar follow-up",
				modalHint: "El follow-up empieza después de que envías un mensaje. La acción solo corre si el cliente no responde.",
				summary: {
					active: "Sectores con follow-up",
					activeHint: "Reglas activas en este momento.",
					how: "Cómo funciona",
					howHint: "1) Envías un mensaje. 2) Si el cliente no responde en X horas, envía el follow-up. 3) Si aún no responde, aplica la acción.",
				},
				table: {
					queue: "Sector",
					status: "Estado",
					delays: "Plazos (msg / acción)",
					action: "Acción",
					actions: "Acciones",
				},
				fields: {
					enabled: "Activar follow-up en este sector",
					body: "Mensaje",
					bodyPlaceholder: "Hola, ¿sigues ahí? ¿Puedo ayudarte con algo más?",
					messageHours: "Horas hasta el mensaje",
					actionHours: "Horas hasta la acción después del mensaje",
					action: "Acción si no responde",
					targetQueue: "Sector destino",
					targetUser: "Usuario destino",
					none: "Ninguno",
					closeMode: "Al cerrar el ticket",
					closeSilent: "Cerrar sin enviar mensaje",
					closeSilentHint: "El ticket se resuelve y el cliente no recibe nada además del follow-up ya enviado.",
					closeFarewell: "Cerrar con despedida y evaluación",
					closeFarewellHint: "Envía el mensaje de despedida de la conexión y el enlace de evaluación.",
					tags: "Tags después de la acción",
					tagsHint: "Opcional. Se aplican al ticket/contacto si el cliente no responde y corre la acción. Déjelo vacío para no marcar nada.",
					tagsEmpty: "No hay tags.",
				},
				actionPending: "Mover a pendiente",
				actionClose: "Cerrar ticket",
				actionChangeQueue: "Cambiar de sector",
				actionTransferUser: "Transferir a un usuario",
				buttons: {
					configure: "Configurar",
					save: "Guardar",
					saving: "Guardando…",
					cancel: "Cancelar",
				},
				toasts: {
					saved: "Follow-up guardado.",
				},
				errors: {
					bodyRequired: "Informa el mensaje para activar el follow-up.",
					queueRequired: "Elige el sector destino.",
					userRequired: "Elige el usuario destino.",
				},
			},
			queues: {
				title: "Sectores",
				notifications: {
					queueDeleted: "Sector eliminado correctamente.",
				},
				table: {
					name: "Nombre",
					color: "Color",
					greeting: "Mensaje de saludo",
					actions: "Acciones",
					startWork: "Apertura",
					endWork: "Cierre",
				},
				buttons: {
					add: "Agregar sector",
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage:
						"¿Está seguro? Esta acción no se puede deshacer. Los tickets de este sector seguirán existiendo, pero ya no tendrán ningún sector asignado.",
				},
			},
			queueSelect: {
				inputLabel: "Sectores",
			},
			autoQueueSelect: {
				inputLabel: "Chatbot: selección automática de sector",
				empty: "Ningún sector seleccionado",
			},
			chatbotMaxAttempts: "Chatbot: máximo de intentos",
			quickAnswers: {
				title: "Respuestas rápidas",
				subtitle: "Atajos de mensaje para usar en las conversaciones",
				listTitle: "Lista de respuestas",
				empty: "No se encontraron respuestas rápidas.",
				emptyHint: "Pruebe con otro término de búsqueda.",
				pagination: {
					label: "Paginación",
					showing: "Mostrando {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Siguiente",
				},
				selectAll: "Seleccionar todas en la lista",
				selectRow: "Seleccionar {{shortcut}}",
				selectedCount: "{{count}} seleccionada(s)",
				table: {
					shortcut: "Atajo",
					message: "Mensaje",
					file: "Archivo",
					hasFile: "Sí",
					actions: "Acciones",
				},
				buttons: {
					add: "Agregar respuesta",
					deleteSelected: "Eliminar seleccionadas",
					edit: "Editar",
					delete: "Eliminar",
				},
				toasts: {
					deleted: "Respuesta rápida eliminada correctamente.",
					deletedSelected: "Respuestas seleccionadas eliminadas correctamente.",
				},
				searchPlaceholder: "Buscar...",
				confirmationModal: {
					deleteTitle:
						"¿Está seguro de que desea eliminar esta respuesta rápida?",
					deleteMessage: "Esta acción no se puede deshacer.",
					deleteSelectedTitle: "¿Eliminar respuestas seleccionadas?",
					deleteSelectedMessage:
						"Se eliminarán {{count}} respuesta(s). Esta acción no se puede deshacer.",
				},
			},
			users: {
				title: "Usuarios",
				table: {
					name: "Nombre",
					email: "Correo Electrónico",
					profile: "Perfil",
					whatsapp: "Conexión estándar",
					actions: "Acciones",
				},
				buttons: {
					add: "Agregar usuario",
				},
				toasts: {
					deleted: "Usuario eliminado correctamente.",
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage:
						"Toda la información del usuario se perderá. Los tickets abiertos de este usuario se moverán a la cola de espera.",
				},
			},
			templates: {
				title: "Plantillas",
				table: {
					type: "Tipo",
					status: "Estado",
					name: "Nombre",
					email: "Correo Electrónico",
					category: "Categoría",
					profile: "Perfil",
					whatsapp: "Conexión predeterminada",
					actions: "Acciones",
					header: "Encabezado",
					body: "Cuerpo",
					footer: "Pie de página",
					statuses: {
						APPROVED: "Aprobado",
						PENDING: "Pendiente",
						REJECTED: "Rechazado",
					},
					types: {
						UTILITY: "Utilidad",
						MARKETING: "Marketing",
						AUTHENTICATION: "Autenticación",
					},
				},
				buttons: {
					add: "Agregar plantilla",
				},
				toasts: {
					deleted: "Plantilla eliminada con éxito.",
				},
				templateModal: {
					title: {
						create: "Agregar plantilla",
						update: "Editar plantilla",
					},
					connection: "Conexión",
					name: "Nombre",
					header: "Encabezado",
					body: "Cuerpo",
					footer: "Pie de página",
					buttons: {
						create: "Crear",
						update: "Actualizar",
						cancel: "Cancelar",
					},
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage: "Todos los datos de la plantilla se perderán.",
				},
			},
			schedules: {
				title: "Programaciones",
				subtitle: "Organiza mensajes programados y acompaña el estado de los envíos.",
				listTitle: "Lista de programaciones",
				searchPlaceholder: "Buscar programación...",
				empty: "No se encontraron agendamientos.",
				emptyHint: "Pruebe con otro término de búsqueda.",
				templateLabel: "Plantilla: {{id}}",
				pagination: {
					label: "Paginación",
					showing: "Mostrando {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Siguiente",
				},
				confirmationModal: {
					deleteTitle: "¿Está seguro de que desea eliminar esta programación?",
					deleteMessage: "Esta acción no se puede revertir.",
				},
				table: {
					contact: "Contacto",
					body: "Mensaje",
					sendAt: "Fecha de programación",
					sentAt: "Fecha de envío",
					status: "Status",
					actions: "Acciones",
				},
				buttons: {
					add: "Nueva programación",
					edit: "Editar",
					delete: "Eliminar",
				},
				toasts: {
					deleted: "Programación eliminada correctamente.",
				},
			},
			scheduleModal: {
				title: {
					add: "Nueva programación",
					edit: "Editar programación",
				},
				subtitle: "Configure conexión, contacto, contenido y fecha de envío.",
				form: {
					connection: "Conexión de origen",
					connectionHint: "Seleccione la conexión antes de buscar un contacto.",
					body: "Mensaje",
					contact: "Contacto",
					searchContact: "Buscar contacto",
					searchContactHint: "Escriba al menos 3 caracteres para buscar.",
					contactSearchEmpty: "No se encontraron contactos.",
					sendAt: "Fecha de programación",
					sentAt: "Fecha de envío",
					media: "Archivo",
					attachFile: "Adjuntar archivo",
					removeFile: "Quitar archivo",
					mediaHint: "Medios aceptados: jpg, jpeg, png, mp4 y pdf.",
					messageHint: "Para insertar variables en el mensaje, escriba \"$\".",
					templateSection: "Plantilla aprobada",
					templateSectionHint: "Seleccione una plantilla aprobada para el envío.",
					templateParams: "Parámetros de la plantilla",
					paramText: "Texto libre",
					paramContactName: "Nombre del contacto",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				variablesTitle: "Variables del mensaje",
				statusLabel: "Estado",
				contactRequired:
					"Seleccione un contacto de los resultados de búsqueda antes de guardar.",
				success: "Programación guardada correctamente.",
			},
			tags: {
				title: "Etiquetas",
				subtitle: "Administración",
				listTitle: "Lista de etiquetas",
				countLabel: "registros",
				searchPlaceholder: "Buscar etiqueta...",
				empty: "No se encontraron etiquetas.",
				emptyHint: "Pruebe con otro término de búsqueda.",
				pagination: {
					label: "Paginación",
					showing: "Mostrando {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Siguiente",
				},
				selectAll: "Seleccionar todas en la lista",
				selectRow: "Seleccionar {{name}}",
				selectedCount: "{{count}} seleccionada(s)",
				confirmationModal: {
					deleteTitle: "¿Está seguro de que desea eliminar esta etiqueta?",
					deleteMessage: "Esta acción no se puede revertir.",
					deleteSelectedTitle: "¿Eliminar etiquetas seleccionadas?",
					deleteSelectedMessage:
						"Se eliminarán {{count}} etiqueta(s). Esta acción no se puede revertir.",
				},
				table: {
					id: "ID",
					name: "Nombre",
					color: "Color",
					tickets: "Registros etiquetados",
					actions: "Acciones",
					contacts: "Contactos",
					absentTag: "Etiqueta ausente",
					absentTagYes: "Sí",
				},
				buttons: {
					add: "Agregar etiqueta",
					deleteSelected: "Eliminar seleccionadas",
					edit: "Editar",
					delete: "Eliminar",
				},
				toasts: {
					deleted: "Etiqueta eliminada correctamente.",
					deletedSelected: "Etiquetas seleccionadas eliminadas correctamente.",
				},
			},
			settings: {
				success: "Configuración guardada satisfactoriamente.",
				title: "Configuración",
				apiKey: {
					regenerate: "Regenerar API Key",
					regenerateConfirm: "¿Generar una nueva API Key? La anterior dejará de funcionar. Copie la nueva clave después de confirmar.",
					regenerateSuccess: "Nueva API Key generada. Cópiela y guárdela en un lugar seguro.",
					regenerateWarning: "Al regenerar, la clave anterior deja de funcionar. Use la nueva clave en las integraciones.",
				},
				settings: {
					userCreation: {
						name: "Creación de usuarios",
						options: {
							enabled: "Habilitado",
							disabled: "Deshabilitado",
						},
					},
					CheckMsgIsGroup: {
						name: "Ignorar mensajes de grupos",
						options: {
							enabled: "Habilitado",
							disabled: "Deshabilitado",
						},
					},
					call: {
						name: "Aceptar llamadas",
						note: "Si está deshabilitado, el cliente recibirá un mensaje indicando que no se aceptan llamadas de voz ni video.",
						options: {
							enabled: "Habilitado",
							disabled: "Deshabilitado",
						},
					},
					sideMenu: {
						name: "Menú lateral inicial",
						note: "Si está habilitado, el menú lateral comenzará cerrado.",
						options: {
							enabled: "Abierto",
							disabled: "Cerrado",
						},
					},
					closeTicketApi: {
						name: "Cerrar ticket enviado por la API",
						note: "Cierra automáticamente el ticket cuando se envía a través de la API.",
						options: {
							enabled: "Habilitado",
							disabled: "Deshabilitado",
						},
					},
					darkMode: {
						name: "Activar modo oscuro",
						note: "Alterna entre el modo claro y el modo oscuro.",
						options: {
							enabled: "Habilitado",
							disabled: "Deshabilitado",
						},
					},
					businessTimezone: {
						name: "Zona horaria",
						note: "Define la zona horaria usada para mostrar fechas, horarios y filtros del sistema.",
						options: {
							zone_serverDefault: "Predeterminado del sistema",
						},
					},
					timeCreateNewTicket: {
						name: "Crear un nuevo ticket después de",
						note: "Selecciona cuánto tiempo debe esperar el sistema antes de abrir un nuevo ticket si el cliente vuelve a contactarte.",
						options: {
							10: "10 segundos",
							30: "30 segundos",
							60: "1 minuto",
							300: "5 minutos",
							1800: "30 minutos",
							3600: "1 hora",
							7200: "2 horas",
							21600: "6 horas",
							43200: "12 horas",
							86400: "24 horas",
							604800: "7 días",
							1296000: "15 días",
							2592000: "30 días",
						},
					},
					sortBy: {
						nameOpen: "Ordenar tickets abiertos por",
						namePending: "Ordenar tickets pendientes por",
						nameClosed: "Ordenar tickets cerrados por",
						note: "Seleccione el orden en que desea ver los tickets.",
						options: {
							asc: "Más antiguos primero",
							desc: "Más recientes primero",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Asignado a:",
					buttons: {
						return: "Devolver",
						resolve: "Resolver",
						reopen: "Reabrir",
						accept: "Aceptar",
						solverWithoutGoodbye: "Solucionador sin adiós",
					},
				},
			},
			messagesInput: {
				placeholderOpen:
					"Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
				placeholderClosed:
					"Vuelva a abrir o acepte este ticket para enviar un mensaje.",
				signMessage: "Firmar",
				stickerPicker: {
					title: "Stickers",
					mine: "Míos",
					company: "Empresa",
					upload: "Nuevo",
					send: "Enviar sticker",
					loading: "Cargando...",
					emptyMine: "No hay stickers guardados. Guarde uno en el chat.",
					emptyCompany: "Aún no hay stickers de la empresa.",
					invalidEmpty: "Sticker inválido o vacío.",
					invalidSize: "El sticker debe tener como máximo 512 KB (512000 bytes).",
					invalidMime:
						"Formato inválido. Use image/webp (o application/octet-stream). PNG/JPEG no son aceptados.",
					remove: "Eliminar sticker",
					deleted: "Sticker eliminado",
					deletedCompany: "Sticker eliminado del pack de la empresa",
					deleteCompanyForbidden:
						"Solo el admin puede eliminar stickers de la empresa",
					emojiTab: "Emojis",
				},
				micPermissionDeniedTitle: "Micrófono bloqueado",
				micPermissionDenied:
					"Permita el acceso al micrófono para grabar audio en esta conversación.",
				micPermissionDeniedHint:
					"En el navegador, haga clic en el candado junto a la URL y configure Micrófono como Permitir. Luego recargue la página.",
				micNotFoundTitle: "Micrófono no encontrado",
				micNotFound:
					"No se detectó ningún micrófono en este dispositivo.",
				micInUseTitle: "Micrófono en uso",
				micInUse:
					"El micrófono está siendo usado por otra aplicación. Ciérrela e intente de nuevo.",
				micInsecureTitle: "Conexión no segura",
				micInsecure:
					"La grabación de audio requiere HTTPS o localhost.",
				micUnknownTitle: "Error al acceder al micrófono",
				micUnknown:
					"No fue posible iniciar la grabación. Verifique los permisos del navegador e intente de nuevo.",
				dismissMicAlert: "Entendido",
				composerTabsLabel: "Modo de envío",
				composerTabReply: "Responder",
				composerTabPrivate: "Mensaje privado",
				composerTabAiReport: "Informe IA",
				privateMessagePlaceholder: "Escriba una anotación",
				privateMessageAlertTitle: "Mensaje privado",
				privateMessageTimelineBadge: "Solo equipo",
				privateMessageAlert:
					"Esta anotación es visible solo para su equipo. El cliente no recibe ni ve este contenido.",
				privateMessageAlertHint:
					"Use este modo para registrar observaciones internas, recordatorios o información sensible del atendimiento.",
				privateMessageHistoryTitle: "Historial de mensajes privados",
				privateMessageHistoryHint:
					"Solo anotaciones de este ticket. El cliente no ve este contenido.",
				privateMessageHistoryEmpty:
					"Aún no hay mensajes privados para este atendimiento.",
				privateMessageTicketRef: "Ticket #{{id}}",
				privateMessageUnknownAuthor: "Agente",
				dismissPrivateMessageAlert: "Entendido",
				aiReport: {
					panelTitle: "Informe IA",
					panelHint:
						"La IA analiza la conversación de este ticket y genera un resumen con problemas, tono emocional y conclusión. El cliente no ve este contenido.",
					generate: "Generar informe",
					generating: "Generando informe...",
					generatedSuccess: "Informe generado con éxito",
					emptyTitle: "Aún no hay informes",
					emptyHint:
						"Haga clic en Generar informe para analizar esta conversación.",
					ticketBadge: "Ticket #{{id}}",
					currentTicket: "Ticket actual",
					summary: "Resumen",
					problems: "Problemas",
					noProblems: "No se identificaron problemas específicos.",
					emotion: "Tono emocional",
					emotionUnknown: "indefinido",
					conclusion: "Conclusión",
					generatedBy: "Generado por {{name}}",
				},
			},
			contactDrawer: {
				header: "Detalles del contacto",
				buttons: {
					edit: "Editar contacto",
				},
				extraInfo: "Otra información",
				bookings: {
					title: "Horarios marcados",
					empty: "Ningún horario marcado para este contacto.",
					disconnected: "Google Agenda no está conectada.",
					add: "Agregar horario",
					loading: "Cargando…",
					save: "Guardar",
					cancel: "Cancelar",
					titleLabel: "Título",
					descriptionLabel: "Descripción",
					startLabel: "Inicio",
					endLabel: "Fin",
					saveSuccess: "Horario agendado con éxito.",
					saveError: "No se pudo agendar.",
					loadError: "No se pudieron cargar los horarios.",
					sourceAi: "IA",
					sourceManual: "Usuario",
					statusScheduled: "Agendado",
					statusCompleted: "Concluido",
					statusCancelled: "Cancelado",
					statusPostponed: "Aplazado",
					changedBy: "Cambiado por",
					reason: "Motivo",
					changeStatus: "Estado",
					reasonOptional: "Motivo (opcional)",
					statusSaved: "Estado actualizado.",
					statusSaveError: "No se pudo actualizar el estado.",
					seeAll: "Ver todos los agendamientos",
					postponedBy: "Aplazado por",
					newStart: "Nueva fecha/hora de inicio",
					newEnd: "Nueva fecha/hora de fin",
					postponeRequired: "Informe la nueva fecha y hora para aplazar.",
					postponeInvalidRange: "El fin debe ser después del inicio.",
					channelLabel: "Canal",
					channelUnknown: "No se informó de dónde vino",
					channelReferral: "Indicación",
					channelSite: "Sitio",
					channelOther: "Otro",
					channelOtherLabel: "¿Cuál canal?",
					channelOtherPlaceholder: "Ej.: TikTok, radio, folleto…",
					referredByLabel: "Quién indicó",
					referredByPlaceholder: "Nombre de quien indicó",
					reminderScheduled: "Mensaje programado",
				},
			},
			searchDrawer: {
				header: "Buscar mensaje",
				searchLabel: "Buscar",
				yesterday: "ayer",
				locale: "es",
			},
			ticketOptionsMenu: {
				delete: "Borrar",
				transfer: "Transferir",
				confirmationModal: {
					title: "¿Borrar ticket #",
					titleFrom: "del contacto ",
					message:
						"¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
				},
				confirmationbukuModal: {
					title: "Eliminar los tickets seleccionados",
					message: "¡Atención! Se perderán todos los mensajes relacionados con los tickets."
				},
				buttons: {
					delete: "Borrar",
					cancel: "Cancelar",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancelar",
				},
			},
			messageOptionsMenu: {
				delete: "Borrar",
				edit: "Editar",
				edited: "Editada",
				editEmpty: "Escribe el nuevo texto del mensaje",
				editSuccess: "Mensaje editado",
				reply: "Responder",
				saveSticker: "Guardar sticker",
				saveStickerCompany: "Guardar sticker de la empresa",
				stickerSaved: "Sticker guardado",
				stickerAlreadySaved: "El sticker ya estaba guardado",
				editModal: {
					title: "Editar mensaje",
					confirm: "Guardar",
				},
				confirmationModal: {
					title: "¿Borrar mensaje?",
					message: "Esta acción no puede ser revertida.",
				},
			},
			languages: {
				undefined: "Idioma",
				"pt-BR": "Portugués",
				es: "Español",
				en: "Inglés",
			},
			tagModal: {
				title: {
					add: "Crear etiqueta",
					edit: "Editar etiqueta",
				},
				form: {
					name: "Nombre",
					color: "Color",
					pickColor: "Elegir color",
					absentTag: "Etiqueta ausente",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Etiqueta guardada con éxito.",
			},
			backendErrors: {
				TICKET_NOT_FOUND: "Ticket no encontrado.",
				ERR_INVALID_NUMBER_LENGTH: "Número demasiado largo (máximo 15 dígitos con código de país).",
				ERR_INVALID_BR_NUMBER: "Número brasileño inválido: use 55 + código de área + número.",
				ERR_TAG_NAME_ALREADY_EXISTS: "Ya existe una etiqueta con ese nombre.",
				ERR_NO_OTHER_WHATSAPP:
					"Debe haber al menos una conexión de WhatsApp predeterminada.",
				ERR_NO_DEF_WAPP_FOUND:
					"No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
				ERR_WAPP_NOT_INITIALIZED:
					"Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
				ERR_WAPP_CHECK_CONTACT:
					"No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
				ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
				ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
				ERR_SENDING_WAPP_MSG:
					"Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
				ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
				ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
				ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
				ERR_USER_CREATION_DISABLED:
					"La creación de usuarios fue deshabilitada por el administrador.",
				ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
				ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
				ERR_COMPANY_NOT_FOUND_FOR_USER:
					"No se pudo identificar la empresa del usuario para esta operación.",
				ERR_NO_SETTING_FOUND:
					"No se encontró ninguna configuración con este ID.",
				ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
				ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
				ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
				ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
				ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
				ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
				ERR_FETCH_WAPP_MSG:
					"Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"Este color ya está en uso, elija otro.",
				ERR_CNPJ_INVALID: "CNPJ inválido.",
				ERR_CNPJ_ALREADY_REGISTERED: "Este CNPJ ya está registrado.",
				ERR_INVALID_EMAIL: "Correo inválido.",
				ERR_SIGNUP_RATE_LIMIT: "Demasiados intentos. Intenta en 15 minutos.",
				ERR_EMAIL_SEND_FAILED: "No se pudo enviar el correo. Intenta más tarde.",
				ERR_INVALID_RESET_TOKEN: "Enlace inválido o expirado. Solicite la recuperación nuevamente.",
				ERR_INVALID_CODE: "Código inválido.",
				ERR_INVALID_OR_EXPIRED_CODE: "Código inválido o expirado.",
				ERR_VERIFICATION_TOKEN_REQUIRED: "El token de verificación es obligatorio.",
				ERR_VERIFICATION_TOKEN_INVALID: "Token de verificación inválido o expirado.",
				ERR_VERIFICATION_TOKEN_MISMATCH: "Los datos no coinciden con la verificación.",
				ERR_VERIFICATION_TOKEN_ALREADY_USED: "Este enlace de verificación ya fue utilizado.",
				ERR_PASSWORD_MIN_LENGTH: "La contraseña debe tener al menos 8 caracteres.",
				ERR_PASSWORD_UPPERCASE: "La contraseña debe tener al menos una mayúscula.",
				ERR_PASSWORD_SPECIAL: "La contraseña debe tener al menos un carácter especial.",
				ERR_WAPP_GREETING_REQUIRED:
					"El mensaje de saludo es obligatorio cuando hay más de una cola.",
				ERR_USER_CREATION_COUNT:
					"Límite de usuarios alcanzado para esta empresa. Cada empresa puede tener 2 usuarios además del administrador.",
				ERR_CANNOT_REMOVE_COMPANY_OWNER:
					"El administrador de la empresa no puede ser eliminado.",
				ERR_CONNECTION_CREATION_COUNT:
					"Se alcanzó el límite de conexión, para cambiar, comuníquese con el soporte.",
			},
		},
	},
};

export { messages };
